(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
      function initSizeGuide(trigger) {
        var modalId = trigger.getAttribute('data-size-guide-trigger');
        var overlay = document.getElementById(modalId);
        if (!overlay) return;

        var closeBtn = overlay.querySelector('[data-size-guide-close]');

        function openModal() {
          overlay.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
          if (closeBtn) closeBtn.focus();
        }

        function closeModal() {
          overlay.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
          trigger.focus();
        }

        trigger.addEventListener('click', openModal);

        if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        }

        overlay.addEventListener('click', function (event) {
          if (event.target === overlay) closeModal();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !overlay.hidden) {
            closeModal();
          }
        });
      }

      document
        .querySelectorAll('[data-size-guide-trigger]')
        .forEach(initSizeGuide);
    })();
  } catch(e) { console.error(e); }
})();

})();
